import { Font } from "@react-pdf/renderer";
import { colors as brandColors } from "@/theme/colors";

Font.register({
  family: "Roboto",
  fonts: [
    { src: "/fonts/Roboto-Light.ttf", fontWeight: 300 },
    { src: "/fonts/Roboto-Regular.ttf", fontWeight: 400 },
    { src: "/fonts/Roboto-Medium.ttf", fontWeight: 500 },
    { src: "/fonts/Roboto-Bold.ttf", fontWeight: 700 },
    { src: "/fonts/Roboto-Italic.ttf", fontWeight: 400, fontStyle: "italic" },
  ],
});

Font.registerHyphenationCallback((word) => [word]);

export const FONT_FAMILY = "Roboto";

export const colors = {
  pageBackground:  brandColors.white.light,
  cardBackground:  brandColors.white.light,
  promptCardBg:    brandColors.peach.DEFAULT,
  textPrimary:     brandColors.grey.black.light,
  textSecondary:   brandColors.grey.main.light,
  textMuted:       brandColors.grey.hover.light,
  border:          brandColors.peach[1],
  tableHeaderBg:   brandColors.peach.DEFAULT,
  kpiCardBg:       brandColors.peach.DEFAULT,
  kpiCardBorder:   brandColors.peach[1],
  accentGreen:     brandColors.pif.green,
  accentGold:      brandColors.pif.gold,
  accentDanger:    brandColors.negative.primary.light,
  link:            brandColors.pif.green,
  evenRowBg:       brandColors.grey.sky.light,
} as const;

export const LIGHT_PALETTE: Record<string, string> = { ...brandColors.chartSeries.light };

const FALLBACK_COLORS = [
  LIGHT_PALETTE.primary,
  LIGHT_PALETTE.secondary,
  LIGHT_PALETTE.danger,
  LIGHT_PALETTE.accent_1,
  LIGHT_PALETTE.accent_3,
  LIGHT_PALETTE.neutral,
];

export const resolveColor = (token?: string | null): string => {
  if (!token) return LIGHT_PALETTE.primary;
  return LIGHT_PALETTE[token] ?? LIGHT_PALETTE.primary;
};

export const seriesColor = (index: number, token?: string | null): string => {
  if (token) return resolveColor(token);
  return FALLBACK_COLORS[index % FALLBACK_COLORS.length];
};

export const fontSize = {
  xs: 7.5,
  sm: 8.5,
  md: 9.5,
  lg: 12,
  titleSm: 13,
  titleMd: 18,
} as const;

export const spacing = {
  xs: 2,
  sm: 4,
  md: 6,
  lg: 10,
  xl: 14,
  xxl: 20,
} as const;

export const borderRadius = {
  sm: 4,
  md: 8,
  lg: 16,
  xl: 24,
} as const;
